import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "linem-cookies-accepted"

export default class extends Controller {
  connect() {
    try {
      if (localStorage.getItem(STORAGE_KEY) === "1") {
        this.element.remove()
        return
      }
    } catch (_) {
      // localStorage недоступен (приватный режим и т.п.) — показываем баннер.
    }
    this.element.hidden = false
  }

  accept() {
    try { localStorage.setItem(STORAGE_KEY, "1") } catch (_) {}
    this.element.remove()
  }
}
